import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// State
import { useStaffCard } from "../../state/staffCardState";
import { useStaffCardDetail } from "../../state/staffCardDetailState";
// Components
import { StaffCardDetail } from "./StaffCardDetail";
import { StaffCardForm } from "./StaffCardForm";
import { Loading } from "../../components/Loading";
// MUI
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";

export const StaffCardExisting = ({ id }) => {
  const [staffCard, setStaffCard] = useState({
    filter: {},
    staff: {},
  });

  const [staffDetail, setStaffDetail] = useState({
    filter: {},
    staffdetail: {
      completedOrders: [],
      orders: [],
      draftOrders: [],
      entitlement: [],
      staffsizes: [],
    },
  });

  const { isFetching, isError, isSuccess, error, data } = useStaffCard(id);

  // Success Function
  const successFunc = () => setStaffCard(data.data.data.data.data);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  const {
    isFetching: isFetchingDetail,
    isError: isErrorDetail,
    isSuccess: isSuccessDetail,
    error: errorDetail,
    data: dataDetail,
  } = useStaffCardDetail(id);

  // Success Function
  const successFunc2 = () => setStaffDetail(dataDetail.data.data.data.data);
  // Error Function
  const errorFunc2 = () =>
    console.warn(
      `Error: ${dataDetail.data.status}: ${dataDetail.data.statusText}`,
    );
  // Hook to check the BC API for errors
  useCheckAPI(
    isSuccessDetail,
    dataDetail,
    dataDetail?.data?.status,
    successFunc2,
    errorFunc2,
  );

  return (
    <Stack spacing={4}>
      {!isFetching ? (
        <>
          <Grid
            container
            columns={4}
            sx={{
              justifyContent: "center",

              pt: {
                xs: 2,
                md: 3,
              },
            }}
          >
            <Grid
              size={{
                xs: 4,
                md: 2,
              }}
            >
              <StaffCardForm staffData={staffCard} loading={isFetching} />
            </Grid>
          </Grid>
          <Divider />
          <StaffCardDetail
            staffDetail={staffDetail.staffdetail}
            loading={isFetchingDetail}
          />
        </>
      ) : (
        <Loading />
      )}
    </Stack>
  );
};
